import React from 'react';

interface IEmptyCartIconProps {
	id?: string;
}

export const EmptyCartIcon = ({ id = 'emptyCartIcon' }: IEmptyCartIconProps) => {
	return (
		<svg role="img" width="300" height="160" viewBox="0 0 300 160" fill="none" aria-labelledby={id}>
			<title id={id}>empty cart illustration</title>
			<path
				d="M64.3464 136.049H218.972C218.972 136.049 222.431 112.59 211.601 101.63C197.312 87.2283 164.366 80.2539 156.904 57.2475C149.441 34.2411 108.85 31.5238 90.5573 50.9072C72.2643 70.2905 93.1056 78.9858 68.1688 95.9236C43.2321 112.861 64.3464 136.049 64.3464 136.049Z"
				fill="#EBEBEB"
			/>
			<rect
				x="112.606"
				y="61.1871"
				width="27.835"
				height="27.835"
				rx="3.5"
				transform="rotate(-14.0264 112.606 61.1871)"
				fill="#F6F6F6"
				stroke="#D6D6D6"
				strokeDasharray="2 2"
			/>
			<rect
				x="137.558"
				y="51.7604"
				width="27.835"
				height="27.835"
				rx="3.5"
				transform="rotate(5.62002 137.558 51.7604)"
				fill="#F6F6F6"
				stroke="#D6D6D6"
				strokeDasharray="2 2"
			/>
			<rect
				x="162.137"
				y="53.198"
				width="27.835"
				height="27.835"
				rx="3.5"
				transform="rotate(27.2774 162.137 53.198)"
				fill="#F6F6F6"
				stroke="#D6D6D6"
				strokeDasharray="2 2"
			/>
			<path
				d="M93.8863 79.3337C92.9658 76.7308 94.8965 74 97.6574 74H202.463C205.19 74 207.117 76.6679 206.261 79.2564L188.396 133.256C187.854 134.894 186.323 136 184.598 136H116.755C115.06 136 113.549 134.932 112.984 133.334L93.8863 79.3337Z"
				fill="white"
			/>
			<path
				d="M156.5 105C156.5 101.134 153.59 98 150 98C146.41 98 143.5 101.134 143.5 105"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<rect x="121" y="100" width="12" height="6" rx="3" fill="#EBEBEB" />
			<rect x="167" y="100" width="12" height="6" rx="3" fill="#EBEBEB" />
			<circle cx="131" cy="99" r="4" fill="#A6A6A6" />
			<circle cx="169" cy="99" r="4" fill="#A6A6A6" />
			<path
				d="M94.8291 79.0003C94.1387 77.0481 95.5867 75 97.6574 75H202.463C204.508 75 205.954 77.0009 205.312 78.9423L187.446 132.942C187.04 134.171 185.892 135 184.598 135H116.755C115.484 135 114.351 134.199 113.927 133L94.8291 79.0003Z"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path
				d="M123 49C123 45.134 126.134 42 130 42H170C173.866 42 177 45.134 177 49V75H123V49Z"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<rect x="139" y="39" width="23" height="7" rx="3" fill="#ffcc00" stroke="#A6A6A6" strokeWidth="2" />
			<circle cx="210.5" cy="53.5" r="6.5" fill="#EBEBEB" />
			<circle cx="200" cy="66" r="4" fill="#EBEBEB" />
			<path d="M106 135H196" stroke="#A6A6A6" strokeWidth="1.96721" />
			<circle cx="231" cy="27" r="20" fill="#EBEBEB" />
			<path
				d="M231.951 29.0625H229.786V28.1062C229.786 25.725 232.564 25.8375 232.564 24.1312C232.564 23.3437 232.023 22.7813 230.851 22.7813C230.544 22.7813 230.201 22.8 229.894 22.8375V24.2812H228V21.4687C228.866 21.1687 229.93 21 231.229 21C233.629 21 235 22.0312 235 23.9062C235 26.7188 231.951 26.55 231.951 28.35V29.0625ZM230.941 33C230.093 33 229.479 32.3062 229.479 31.5C229.479 30.6937 230.093 30.0375 230.941 30.0375C231.807 30.0375 232.42 30.6937 232.42 31.5C232.42 32.3062 231.807 33 230.941 33Z"
				fill="#A6A6A6"
			/>
			<g>
				<path d="M150.5 134C130.5 119.5 123.5 106.5 123.5 75.5H94.5L114 134H150.5Z" fill="#F6F6F6" />
			</g>
		</svg>
	);
};
